import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const activityTabEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-activity-tab" */ './index'),
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
